import i18n, { InitOptions } from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector';
import LocizeBackend from 'i18next-locize-backend'

const isProd = import.meta.env.REACT_APP_UI_ENV === "Prod";

const locizeOptions = {
  projectId: '9d0a9702-0bc0-44cc-8318-ab23115c1fbf', //Project Id found from the Locize webpage
  apiKey: import.meta.env.REACT_APP_LOCIZE_APIKEY, // The API key should only be used in development, not in production. You should not expose your apps API key to production!!!
  referenceLng: 'en',
  version: isProd ? "production" : "development", //Version is the locize branch of the project
};

i18n
  // i18next-locize-backend
  // loads translations from your project, saves new keys to it (saveMissing: true)
  // https://github.com/locize/i18next-locize-backend
  .use(LocizeBackend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // Bind i18next to React
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: !isProd, // Enable logging for development
    supportedLngs: ['en', 'de', 'es', 'fr', 'pt-BR'],
    fallbackLng: 'en', // Default language
    backend: locizeOptions,
    saveMissing: !isProd, // you should not use saveMissing in production
    defaultNS: 'translation',
    ns: ['Dashboard', 'Alerts', 'FilterPanel', 'Commodities', 'Positions', 'Bids', 'Offers&Contracts', 'Producers', "Common"],
  } as InitOptions)

export { default as i18n } from 'i18next'